import React, { useEffect, useState } from 'react';
import api from '../api';
import './testimonial.css';

const fallbackTestimonials = [
  {
    id: 'fallback-1',
    quote:
      'Financial Experts gave us a cleaner reporting structure and helped us make decisions with actual confidence instead of guesswork.',
    name: 'Amina Yusuf',
    company: 'Northbridge Retail',
    role: 'Operations Director',
    rating: 5,
    avatar: '',
  },
  {
    id: 'fallback-2',
    quote:
      'Their team untangled our bookkeeping backlog and built a tax workflow that removed constant deadline pressure.',
    name: 'David Okeke',
    company: 'Oakline Ventures',
    role: 'Founder',
    rating: 5,
    avatar: '',
  },
  {
    id: 'fallback-3',
    quote:
      'We moved from reactive finance operations to a measurable monthly process with clear visibility across the business.',
    name: 'Grace Mensah',
    company: 'Summit Logistics',
    role: 'Finance Lead',
    rating: 4,
    avatar: '',
  },
];

const renderStars = rating => '★'.repeat(Math.max(1, Math.min(5, rating || 5)));

const getInitials = name => {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return 'FE';
  return parts.slice(0, 2).map(part => part[0].toUpperCase()).join('');
};

const TestimonialBox = () => {
  const [testimonials, setTestimonials] = useState(fallbackTestimonials);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const loadTestimonials = async () => {
      try {
        const response = await api.get('/testimonials');
        const items = Array.isArray(response.data) ? response.data : [];
        if (mounted && items.length > 0) {
          setTestimonials(items);
        }
      } catch (error) {
        console.error('Failed to load testimonials', error);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadTestimonials();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="testimonial_box">
      <div className="container">
        <div className="testimonial_intro">
          <span className="testimonial_eyebrow">Client voices</span>
          <h2>Trusted by businesses that need their numbers handled properly</h2>
          <p>
            From bookkeeping cleanups to tax planning and operational finance support, these are the
            outcomes clients point to most often.
          </p>
        </div>

        <div className="testimonial_grid">
          {testimonials.map(testimonial => (
            <article key={testimonial.id} className="testimonial_card">
              <div className="testimonial_rating" aria-label={`${testimonial.rating || 5} star rating`}>
                {renderStars(testimonial.rating)}
              </div>
              <p className="testimonial_quote">“{testimonial.quote}”</p>
              <div className="testimonial_footer">
                {testimonial.avatar ? (
                  <img
                    className="testimonial_avatar"
                    src={testimonial.avatar}
                    alt={`Portrait of ${testimonial.name}`}
                  />
                ) : (
                  <div className="testimonial_avatar testimonial_avatar-fallback" aria-hidden="true">
                    {getInitials(testimonial.name)}
                  </div>
                )}
                <div>
                  <div className="testimonial_name">{testimonial.name}</div>
                  <div className="testimonial_meta">
                    {testimonial.role ? `${testimonial.role}, ` : ''}
                    {testimonial.company}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {loading && <p className="testimonial_hint">Loading latest testimonials…</p>}
        {!loading && testimonials === fallbackTestimonials && (
          <p className="testimonial_hint">Showing default testimonials until published items are added in admin.</p>
        )}
      </div>
    </section>
  );
};

export default TestimonialBox;
